import { Injectable } from '@angular/core';
import { contractFilter } from '@models/contract.model';
import { ApiService } from '@services/api/api.service';
import { SharedService } from '@services/api/shared.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { ReduxService } from '@state-management/redux.service';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  constructor(
    private api: ApiService,
    private localStorageService: LocalStorageService,
    private redux: ReduxService,
    private _sharedService: SharedService
  ) {}

  contract_status: any[] = [];
  offer_status: any[] = [];
  office_staff: any[] = [];
  office_staff_list: any[] = [];

  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'))?.toLowerCase();

  filter_param: contractFilter = {
    keyword: '',
    agent: null,
    listing_address: null,
    project_name: null,
    contract_status: null,
    offer_status: null,
    condition_due: null,
    settlement_due: null,
    date: null,
  };
  getAgents() {
    let url: string = '/users/byoffice?office=' + this.api.getOfficeId() + '&show=staff';
    this.redux.getSetProjectInfo(false, 'byOffice', url).subscribe({
      next: response => {
        // Maps the retrieved staff data and constructs the full name
        this.office_staff = JSON.parse(JSON.stringify(response.data));
        this.office_staff = this.office_staff
          ?.filter(el => el?.deactive !== true)
          .map(i => {
            i = { ...i, full_name: i.first_name + ' ' + i.last_name };
            return i;
          })
          .sort((a, b) => a?.full_name.localeCompare(b?.full_name));
      },
    });
  }

  getAgentList() {
    this._sharedService.getModuleAgent('combine_contract_eoi').subscribe({
      next: response => {
        let activeAgent = response?.data?.filter(agent => agent?.deactive === false) || [];
        this.office_staff_list = activeAgent;
      },
    });
  }

  getContractTags() {
    /**
     * Fetches and processes contract-related tags for the current office.
     */
    this.redux.getTags(this.api.getOfficeId(), true, 'contract').subscribe({
      next: response => {
        if (response?.data?.length > 0) {
          response?.data[0]?.types?.forEach(ele => {
            // Sort the tag data alphabetically by tag name
            const sortedData = [...(ele?.data || [])].sort((a, b) => Number(a.tag_order) - Number(b.tag_order));

            switch (ele?.slug) {
              case 'contract-status':
                // Assign sorted contract status
                this.contract_status = sortedData;
                break;
              case 'offer-status':
                // Assign sorted offer status
                this.offer_status = sortedData;
            }
          });
        }
      },
    });
  }
}
